export default {"src":"/_next/static/media/workshop.9e44c920.svg","height":12,"width":15,"blurWidth":0,"blurHeight":0};